import { useResponsive } from '@/hooks';
import { cn } from '@/utils';
import { COMMON_TEXT, SIMULATION_LABELS } from '@/constants';
import { TextContent } from '@/components/Text';
import { TSimulationType } from '@/types';

interface Props {
  certificationTitle?: string;
  className?: string;
  isLoading?: boolean;
  simulationDescription?: string;
  simulationTitle?: string;
  simulationType?: TSimulationType;
}

export const SimulationScenarioPageHeader: React.FC<Props> = ({
  certificationTitle,
  className,
  isLoading,
  simulationDescription,
  simulationTitle,
  simulationType,
}) => {
  const isXlUp = useResponsive({ breakpoint: 'xl', direction: 'min' });

  // ========================================================================
  // Render
  // ========================================================================
  return (
    <section
      className={cn('w-full max-w-6xl', className)}
      data-testid="simulation-page-header-section"
    >
      <div className="flex flex-col space-y-3">
        <TextContent
          isLoading={isLoading}
          label={certificationTitle}
          testId="certification-title"
          type="paragraph"
          variant="bodyMedium"
        />
        <TextContent
          isLoading={isLoading}
          level={1}
          loadingClassName={simulationType === 'role-play' ? 'w-3/4 mt-0.5' : 'w-full'}
          loadingLines={simulationType === 'role-play' ? 2 : 1}
          testId="simulation-title"
          type="headline"
          variant="pageTitle"
        >
          {simulationType === 'role-play' && (
            <span className="block w-full">
              {SIMULATION_LABELS.ROLEPLAY_PRACTICE_SCENARIO + ': '}
            </span>
          )}
          {simulationTitle || COMMON_TEXT.SIMULATION}
        </TextContent>
        <TextContent
          className="!font-bold whitespace-pre-line"
          isLoading={isLoading}
          label={simulationDescription}
          loadingClassName="w-full max-xl:mt-0.5"
          loadingLines={isXlUp ? 2 : 3}
          testId="simulation-description"
          type="paragraph"
          variant="bodyLarge"
        />
      </div>
    </section>
  );
};
